import script from "./LoginCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginCustomer.vue?vue&type=script&setup=true&lang=js"

import "./LoginCustomer.vue?vue&type=style&index=0&id=7007d4df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7007d4df"]])

export default __exports__